import { render } from "./Criar.vue?vue&type=template&id=4e40c0eb"
import script from "./Criar.vue?vue&type=script&lang=js"
export * from "./Criar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__